import React, { useEffect } from "react";
import gsap from "gsap";
import Header from "../components/Home/Header";
import Sidebar from "../components/Home/Sidebar";
import IntroSection from "../components/Home/IntroSection";
import DetailsSection from "../components/Home/DetailsSection";
import FeaturesSection from "../components/Home/FeaturesSection";
import CalculatorSection from "../components/Home/CalculatorSection";
import CardSection from "../components/Home/CardSection";
import FinancialPlanningSection from "../components/Home/FinalcialCardSection";
import ConsultantSection from "../components/Home/Consultant";
import TestPrepSection from "../components/Home/IELTSSection";
import ContactSection from "../components/Home/ContactUs";
import Footer from "../components/Home/Footer";
import whatsappIcon from "../Assets/icons8-whatsapp.svg";

const Home = () => {
  return (
    <div className="bg-black text-white overflow-x-hidden">
      <div className="relative overflow-hidden">
        <Sidebar />
        <Header />
      </div>
      <IntroSection />
      <DetailsSection />
      <TestPrepSection />
      <FeaturesSection />
      <CalculatorSection />
      <CardSection />
      <FinancialPlanningSection />
      <ConsultantSection />
      <ContactSection />
      <Footer />

      {/* WhatsApp Icon */}
      <a
        href="https://wa.me/923348832744"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50"
      >
        <div className="bg-green-500 w-14 h-14 rounded-full flex items-center justify-center shadow-lg hover:bg-green-600 transition-colors duration-300">
          <img src={whatsappIcon} alt="icon" className="size-9" />
        </div>
      </a>
    </div>
  );
};

export default Home;
